import { TrainingPlan, UserDTO } from '@/generated';

export const isPlanEditor = (plan?: TrainingPlan, user?: UserDTO | null) => plan?.creatorId === user?.userId || (plan?.editorIds.includes(user?.userId ?? 'none') ?? false);
export const isPlanViewer = (plan?: TrainingPlan, user?: UserDTO | null) => plan?.viewerIds.includes(user?.userId ?? '');

export const planHasOnlyCreatorUser = (plan: TrainingPlan, userId: string) => {
  return (
    //TODO: This logic is not perfect.
    plan.viewerIds.every((viewerId: string) => viewerId === userId) ||
    plan.editorIds.every((editorId: string) => editorId === userId) ||
    (plan.creatorId === userId && plan.editorIds.length === 0 && plan.viewerIds.length === 0)
  );
};
